var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationBill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 27,
    viewBox: "0 0 23 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 19V19.4142L16.7929 19.7071L18.8358 21.75H1.16421L3.20711 19.7071L3.5 19.4142V19V12.75C3.5 9.24874 5.32187 6.54184 8.35555 5.82306L9.125 5.64075V4.85V4C9.125 3.51478 9.51478 3.125 10 3.125C10.4852 3.125 10.875 3.51478 10.875 4V4.85V5.64011L11.6437 5.82288C14.6662 6.54153 16.5 9.26213 16.5 12.75V19ZM11.114 25C10.8386 25.3062 10.4401 25.5 10 25.5C9.55433 25.5 9.1557 25.3066 8.8816 25H11.114Z",
    fill: "white",
    stroke: "#757575",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationBill);
export default __webpack_public_path__ + "static/media/notification-bill.44440760.svg";
export { ForwardRef as ReactComponent };